export const DOCUMENT_NUDGE_COOLDOWN_MS = 60 * 60 * 1000

export const DOCUMENT_NUDGE_COOLDOWN_TOOLTIP =
	'Available only once per hour'

export const isDocumentNudgeOnCooldown = (lastNudgeAt, now = Date.now()) => {
	if (!lastNudgeAt) return false
	const sentAt = new Date(lastNudgeAt).getTime()
	if (Number.isNaN(sentAt)) return false
	return now - sentAt < DOCUMENT_NUDGE_COOLDOWN_MS
}

export const getDocumentNudgeCooldownRemainingMs = (lastNudgeAt, now = Date.now()) => {
	if (!lastNudgeAt) return 0
	const sentAt = new Date(lastNudgeAt).getTime()
	if (Number.isNaN(sentAt)) return 0
	return Math.max(0, DOCUMENT_NUDGE_COOLDOWN_MS - (now - sentAt))
}
